import React from 'react'
import { Button, Card, Grid, Stack, Typography } from '@mui/material';

const NotesCard = ({ notee, onDelete, onEdit }) => {

    const { _id, note, code, image } = notee;
    return (
        <Card sx={{ mt: '8px' }}>
            <Grid container>
                <Grid item sm={3} justifyContent="center" alignItems={"center"}>
                    <img
                        alt="logo"
                        style={{ width: '150px', height: '300px', objectFit: 'cover', margin: 'auto' }}
                        src={`${process.env.REACT_APP_IMAGE}${image}`}
                    />
                </Grid>
                <Grid item sm={8} p={3}>
                    <Stack direction={'column'}>
                        <Typography variant="h4" color="#A7202C">
                            {code}
                        </Typography>
                        <Typography variant="h6" color="black">
                            {note}
                        </Typography>

                        <Stack sx={{ mt: 18 }} direction="row" justifyContent="space-between">
                            <Stack direction="row" spacing={1}>
                                <Button variant="outlined" color="error"
                                    onClick={() => onDelete(_id)}
                                >
                                    Xóa quảng cáo
                                </Button>
                                <Button variant="outlined" color="success"
                                    onClick={() => onEdit(_id)}
                                >
                                    Cập nhật
                                </Button>
                            </Stack>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}

export default NotesCard